<!-- =========================================================================================
  File Name: VerticalNavMenuGroup.vue
  Description: Vertical NavMenu Group Component. Extends vuesax framework's 'vs-sidebar-group' component
  Component Name: VerticalNavMenuGroup
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div

    v-show="canSee"
    class  = "vs-sidebar-group"
    :class = "[
      {'vs-sidebar-group-open'            : openItems        },
      {'vs-sidebar-group-active'          : open             },
      {'disabled-item pointer-events-none': group.isDisabled },
      {
        'vs-sidebar-group-active-click':
          isClickGroup == group.url && group.name != 'お問い合わせ一覧',
      },
    ]"
    @mouseover = "mouseover"
    @mouseout  = "mouseout">

    <!-- Group Label -->
    <div
      v-if="group.submenu"
      :id="'group-header-index-'+group.index"
      @click="clickGroup"
      class="group-header w-full"
      @dragover="
        group.canEdit &&
          $route.fullPath.includes(group.url.split('/')[2]) &&
          onDragOver($event, group.index)
      "
      @drop="
        group.canEdit &&
          $route.fullPath.includes(group.url.split('/')[2]) &&
          onDrop($event, group.id, group.index)
      "
      @dragleave="
      group.canEdit &&
          $route.fullPath.includes(group.url.split('/')[2]) &&
          onDragLeave(group.index)"
    >
      <span class="flex items-center w-full">

        <!-- Group Icon -->
        <feather-icon
          v-if        = "group.icon  || (this.groupIndex > Math.floor(this.groupIndex))"
          :icon       = "group.icon  || 'CircleIcon'"
          :svgClasses = "{ 'w-3 h-3' : this.groupIndex % 1 != 0 }" />
          <feather-icon
          v-if        = "group.level == 3"
          icon       = "EditIcon"
          @click.stop="openEditUserNamePopup(group)"
          :svgClasses = "{ 'w-3 h-3' : this.groupIndex % 1 != 0 }" />
        <feather-icon
          v-if="group.canEdit && group.parent != undefined"
          icon="EditIcon"
          :svgClasses="{ 'w-3 h-3 ml-5': this.groupIndex % 1 != 0 }"
          @click="activePopup('EDIT', group.mail_server, group.id, group.name , group.url)"
        />
        <feather-icon
          v-if="group.canEdit"
          icon="PlusIcon"
          :svgClasses="{ 'w-3 h-3': this.groupIndex % 1 != 0 }"
          @click="activePopup('ADD', group.mail_server, group.id)"
        />

        <!-- Group Name -->
        <router-link
          v-if="group.redirect && group.url"
          class="w-full"
          @click="clickGroup"
          :to="toGroupPath"
        >
          {{ $t(group.i18n) || group.name }}
        </router-link>
        <span
          v-else
          v-show="!verticalNavMenuItemsMin"
          class="truncate mr-3 select-none"
          >{{ $t(group.i18n) || group.name }}</span
        >

        <!-- Group Tag -->
        <vs-chip
          class="ml-auto mr-4"
          :color="group.tagColor"
          v-if="group.tag && !verticalNavMenuItemsMin"
          >{{ group.tag }}</vs-chip
        >
      </span>

      <!-- Group Collapse Icon -->
      <feather-icon
        v-show     = "!verticalNavMenuItemsMin"
        :class     ="[{ rotate90: isShow(group) }, 'feather-grp-header-arrow']"
        icon       ="ChevronRightIcon"
        svg-classes="w-4 h-4" />

      <!-- Unread Number-->
      <vs-chip
        v-if="group.unreadNum && group.unreadNum != 0"
        :class="group.name == '受信' ? 'ml-auto inbox-unread-num' : 'ml-12 inbox-unread-num' "
        color="danger"
        >{{ group.unreadNum }}</vs-chip
      >

      <!-- Group Tooltip -->
      <span class="vs-sidebar--tooltip">{{ $t(group.i18n) || group.name }}</span>
    </div>
    <!-- /Group Label -->

      <!-- Group Items -->
      <ul  ref="items" :style="styleItems" :class="(!group.id || group.id == 0 ) ? 'vs-sidebar-group-items' : 'vs-sidebar-group-items auto-margin'" v-show="isShow(group)">
          <draggable
                  group="slider"
                  class="list-group"
                  v-bind="dragOptions"
                  :list="group.submenu"
                  :move="checkMove"
                  @end="onDragEnd"
          >
        <li v-for="(groupItem, index) in group.submenu" :key="index" :data-id="index"
            class="list-group-item"
        >
          <!-- If item is group -->
          <v-nav-menu-group
            v-if        = "groupItem.submenu"
            :group      = "groupItem"
            :groupIndex = "Number(`${groupIndex}.${index+1}`)"
            :open       = "isGroupActive(groupItem)"
            :openHover  = "openHover"
            :class="
                  groupItem.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'
                "
            @click="groupItem.fixed = !groupItem.fixed"
            aria-hidden="true"
          >
          </v-nav-menu-group>
          <!-- Else: Item -->
          <v-nav-menu-item
            v-else
            icon-small
            :index="groupIndex + '.' + index"
            :to="groupItem.slug !== 'external' ? groupItem.url : null"
            :href="groupItem.slug === 'external' ? groupItem.url : null"
            :icon="itemIcon(groupIndex + '.' + index)"
            :slug="groupItem.slug"
            :target="groupItem.target"
            :canEdit="groupItem.canEdit"
            :id="groupItem.id"
            :name="groupItem.name"
            :mail_server="groupItem.mail_server"
            :parent="groupItem.parent"
          >
            <span class="truncate">{{
              $t(groupItem.i18n) || groupItem.name
            }}</span>
            <vs-chip
              class="ml-auto"
              :color="groupItem.tagColor"
              v-if="groupItem.tag"
              >{{ groupItem.tag }}</vs-chip
            >
            <vs-chip
              v-if="groupItem.unreadNum && groupItem.unreadNum != 0"
              class="ml-5 inbox-unread-num"
              color="danger"
              >{{ groupItem.unreadNum }}</vs-chip
            >
          </v-nav-menu-item>
        </li>
          </draggable>
      </ul>
      <!-- /Group Items / PAC_21-111-->
      <vs-popup
      id="editUserName"
      title="メールボックス名の編集"
      :active.sync="editUserNameActive"
      button-close-hidden
    >
      <div> 
        <div>
          <p class="my-2">メールボックス名</p>
          <vs-input
            v-validate.immediate="'required|max:64'"
            maxlength="64"
            placeholder="メールボックス名"
            name="メールボックス名"
            id="customUserName"
            v-model="customUserName"
            style="width: 100%"
          />
          <span style="color: red">{{ errors.first("メールボックス名") | convertError }}</span>
        </div>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button
          @click = "setEditUserNameInPopup"
          icon="check"
          :disabled="!customUserName"
          color="success"
          class="mx-2"
          >編集</vs-button
        >
        <vs-button
          @click="editUserNameActive = false"
          icon="cancel"
          color="lightgrey"
          >閉じる</vs-button
        >
      </div>
    </vs-popup>
    </div>
  </template>


<script>
import VNavMenuItem from './VerticalNavMenuItem.vue'
import { mapActions, mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
  name: 'v-nav-menu-group',
  props: {
    openHover  : { type: Boolean, default: false },
    open       : { type: Boolean, default: false },
    group      : { type: Object },
    groupIndex : { type: Number }
  },
  components: {
    VNavMenuItem,
    draggable
  },
  data: () => ({
    editUserNameActive : false,
    customUserName : "",
    selectedGroup: "",
    maxHeight : '0px',
    openItems : false,
    canSee: false,
    displayOrder:[],
  }),
  computed: {
    ...mapGetters({
      reload: "reload",
    }),
      dragOptions() {
          return {
              animation: 0,
              group: "description",
              disabled: false,
              ghostClass: "ghost"
          };
      },
    verticalNavMenuItemsMin () { return this.$store.state.verticalNavMenuItemsMin },
    styleItems () {
      return { maxHeight: 'auto' }
    },
    itemIcon () {
      return (index) => {
        if (this.group.icon === 'PhoneCallIcon') return 'PhoneIcon'
        if (!((index.match(/\./g) || []).length > 1)) return 'MailIcon'
      }
    },
    isGroupActive () {
      return (item) => {
        const path        = this.$route.fullPath
        let open          = false
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined

        const func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (
                (path === item.url || routeParent === item.slug) &&
                item.url
              ) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },

    isClickGroup() {
      let activeGroup = "";
      activeGroup = this.$route.fullPath;
      this.$store.commit("SET_CURRENT_URL_ACTIVE", activeGroup);
      return activeGroup;
    },
    
    validateForm(){
      return !this.errors.any()
    },
    toGroupPath() {
      let queryString = this.group.url;
      if (this.$route.query.mode === 'shachihatadesk') {
        queryString += '?mode=shachihatadesk';
        if (this.$route.query.urlorigin) {
          queryString += `&urlorigin=${this.$route.query.urlorigin}`;
        }
      }
      return queryString;
    }
  },
  watch: {
    // OPEN & CLOSES DROPDOWN ON ROUTE CHANGE
    $route() {
      if (this.verticalNavMenuItemsMin) return

      const scrollHeight = this.scrollHeight
      // Collapse Group
      if (this.openItems && !this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = `${0}px`
        }, 50)

      // Expand Group
      } else if (this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = 'none'
        }, 300)
      }
    },
    maxHeight () {
      this.openItems = this.maxHeight !== '0px'
    },
    // OPEN AND CLOSES DROPDOWN MENU ON NavMenu COLLAPSE AND DEFAULT VIEW
    // '$store.state.verticalNavMenuItemsMin' (val) {
    //   if (this.$refs.items){
    //     const scrollHeight = this.$refs.items.scrollHeight

    //     if (!val && this.open) {

    //       this.maxHeight = `${scrollHeight}px`
    //       setTimeout(()  => {
    //         this.maxHeight = 'none'
    //       }, 300)
    //     } else {

    //       this.maxHeight = `${scrollHeight}px`
    //       setTimeout(()  => {
    //         this.maxHeight = '0px'
    //       }, 50)
    //     }
    //     if (val && this.open) {

    //       this.maxHeight = `${scrollHeight}px`
    //       setTimeout(()  => {
    //         this.maxHeight = '0px'
    //       }, 250)
    //     }
    //   }
    // }
  },
  methods: {
    ...mapActions({
      togglePopup: "togglePopup",
      moveToFolder: "mailFolder/moveToFolder",
      getListMailBox: "receiveMail/getListMailBox",
      updateDisplayOrder: "receiveMail/updateDisplayOrder",
      setMailUserName:  "receiveMail/setMailUserName",
    }),
      checkMove: function(evt){

          //check and prevent drag item to other item has parent other include sub item of mail sever
          const draggedElementType = evt.draggedContext.element.slug;
          const relatedElementType = evt.relatedContext.element.slug;
          let flagDragMailBoxList;

          switch (draggedElementType) {
              case 'subfolder' : flagDragMailBoxList = true
                  break;
              case 'mail-box-list' : flagDragMailBoxList = true
                  break;
              case 'mail-spam-list' : flagDragMailBoxList = true
                  break;
              case 'mail-sent-list' : flagDragMailBoxList = true
                  break;
              case 'mail-sent-failed-list' : flagDragMailBoxList = true
                  break;
              case 'mail-draft-list' : flagDragMailBoxList = true
                  break;
              case 'mail-send-to-multiple' : flagDragMailBoxList = true
                  break;
          }
          if (draggedElementType !== relatedElementType || flagDragMailBoxList) {
              return false;
          }

          this.displayOrder = evt.relatedContext.list.map((e, i) => ({id: e.id,  name: e.name }));
          let draggedElement = this.displayOrder.find((e) => e.name === evt.draggedContext.element.name);
          let futureIndex = evt.draggedContext.futureIndex;
          if (draggedElement) {
              this.displayOrder = this.displayOrder.filter((e) => e.name !== draggedElement.name);
              this.displayOrder.splice(futureIndex, 0, draggedElement);
            }
      },
      onDragEnd(event) {
          const target = event.item;
          const groupItem = this.group.submenu[target.getAttribute('data-id')];
          let tableName;
          //check drag and drop v-nav-menu-item or v-nav-menu-group
          if (groupItem && groupItem.slug === 'box') {
              tableName = 'user_mail_info'
          } else if (groupItem && groupItem.slug === 'telephone-box') {
              tableName = 'user_telephone_info'
              }
          let data = {
              tableName: tableName,
              displayOrder: this.displayOrder.map(item => item.id)
          }
          this.updateDisplayOrder(data)
          },
    updateCanSee() {
      this.$nextTick(() => {
        let result = false
        if (this.$refs.items && this.$refs.items.childNodes){
          this.$refs.items.childNodes.forEach((liNode) => {
            if (liNode.innerHTML !== '<!---->') {
              result = true
            }
          })
        }
        this.canSee = result
      })
    },
    clickGroup() {
      if(this.group.level !== 1) this.group.show = !this.group.show;

      if(this.group.index != 1 && this.group.show){
         this.group.submenu.filter((item) => {
            if(item.show) {
                 return (item.show = false);
            }
            return item
        });
      }
      if(this.group.show){
        this.$store.commit('receiveMail/SET_INDEX_GROUP_OPEN', {index : this.group.index, delete : false})
      }else{
          this.$store.commit('receiveMail/SET_INDEX_GROUP_OPEN', {index : this.group.index, delete : true})
      }
      if (!this.openHover) {

        const thisScrollHeight = this.$refs.items.scrollHeight

        if (this.maxHeight === '0px') {
          this.maxHeight = `${thisScrollHeight}px`
          setTimeout(() => {
            this.maxHeight = 'none'
          }, 300)

        } else {
          this.maxHeight = `${thisScrollHeight}px`
          setTimeout(() => {
            this.maxHeight = `${0}px`
          }, 50)
        }

        this.$parent.$children.map((child) => {
          if (child.isGroupActive) {
            if (child !== this && !child.open && child.maxHeight !== '0px') {
              setTimeout(() => {
                child.maxHeight = `${0}px`
              }, 50)
            }
          }
        })
      }
    },
    mouseover () {
      if (this.openHover) {
        const scrollHeight = this.$refs.items.scrollHeight
        this.maxHeight   = `${scrollHeight}px`
      }
    },
    mouseout () {
      if (this.openHover) {
        const scrollHeight = 0
        this.maxHeight   = `${scrollHeight}px`
      }
    },
    isShow(group) {
      const page_url = this.$route.fullPath;
      if (group.show) {
        return true;
      }
      return false;
    },
    activePopup(type, mail_server, id, name = "",url = "") {
      this.togglePopup({ type, data: { mail_server, id, name, url } });
    },
    onDragOver(event, index) {
      let hover = document.getElementById("group-header-index-"+index);
      hover.classList.add("drag-hover");
      var dragSupported = event.dataTransfer.length;
      if (dragSupported) {
        event.dataTransfer.dropEffect = "move";
      }
      event.preventDefault();
    },
    async onDrop(event, id, index) {
            var jsonData;
            if (event.dataTransfer.getData("application/json")) {
                jsonData = JSON.parse(event.dataTransfer.getData("application/json"));
            }
            if (jsonData) {
                let data = {
                    mailBox: this.$route.params.email,
                    mail_id: jsonData.id,
                    folder_id: id,
                };
                //Move to folder
                await this.moveToFolder(data);
            }
            let unHover = document.getElementById("group-header-index-"+index);
            unHover.classList.remove("drag-hover");
            await this.getListMailBox();
            let folder = null;
            if (this.$route.fullPath.includes("folder") == true) {
                folder =
                    this.$route.fullPath.split("/")[
                    this.$route.fullPath.split("/").length - 1
                        ];
            }
            await this.reload(false, false, this.$route.params.email, folder);

    },
    onDragLeave(index){
      let unHover = document.getElementById("group-header-index-"+index);
      unHover.classList.remove("drag-hover");
    },
    // PAC_21-111
    openEditUserNamePopup(group){
      this.selectedGroup = group;
      this.editUserNameActive = true;
      this.customUserName = group.i18n;
    },
    async setEditUserNameInPopup(){
        if(this.customUserName && this.validateForm){
          await this.setMailUserName({id: this.selectedGroup.id, mail_user_name: this.customUserName });
          this.editUserNameActive = !this.editUserNameActive;
          await this.getListMailBox();
          this.selectedGroup = "";
        }else{
          this.$store.dispatch("alertError", '無効なメールボックス名', { root: true });
          return;
        }
    }
    // END PAC_21-111
  },
  mounted() {
    this.openItems = this.open;
    if (this.open) {
      if (this.verticalNavMenuItemsMin) {
        setTimeout(() => {
          this.maxHeight = `${0}px`
        }, 500);
      } else {
        setTimeout(() => {
          this.maxHeight = 'none'
        }, 300)
      }
    }
  },
  created () {
    if(this.$route.query.mode == 'shachihatadesk'){
      setTimeout(() => {
        const pageUrl = this.$route.params.email;
        if(this.group.name == pageUrl){
          if(this.group.show == false){
            this.group.show = !this.group.show;
          }
        }
      }, 300)
    }
    this.updateCanSee()

    // Watch for ACL role changes
    this.$acl.onChange = () => {
      this.updateCanSee()
    }
  }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenuGroup.scss";
.icon-button {
  position: relative !important;
  top: 10px;
  left: 10px;
  border-radius: 50%;
  background-color: white;
}
.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>
